import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import _ from 'lodash';
import metadata from './CoverageTermsIterableComponent.metadata.json5';
import styles from './CoverageTermsIterableComponent.module.scss';


function CoverageTermsIterableComponent(props) {
    const { data: coveragesTermsData } = props;

    const generateCoverageTermsOverrides = useCallback(() => {
        if (coveragesTermsData.isIncluded === false) {
            if (coveragesTermsData.terms === undefined) {
                const coverageObject = [{
                    amount: 'Not Included',
                    modelType: 'Limit',
                    name: ' '
                }];
                _.set(coveragesTermsData, 'terms', coverageObject);
            }
        } else if (coveragesTermsData.isIncluded === true) {
            if (coveragesTermsData.terms === undefined) {
                const coverageObject = [{
                    amount: 'Included',
                    modelType: 'Limit',
                    name: ' '
                }];
                _.set(coveragesTermsData, 'terms', coverageObject);
            }
        }
        const overrides = coveragesTermsData.terms.map((term, tindex) => {
            return {
                [`coveragesTermsContent${tindex}`]: {
                    label: term.name
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [coveragesTermsData]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        ...generateCoverageTermsOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={coveragesTermsData}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

CoverageTermsIterableComponent.propTypes = {
    data: PropTypes.shape({}).isRequired
};

export default CoverageTermsIterableComponent;
